// extracted by mini-css-extract-plugin
module.exports = {"root":"e_Q8","head":"e_R8","heading":"e_S8","eyebrow":"e_T8","summary":"e_U8","all":"e_V8","rows":"e_W8"};